import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const RenderMarkdown = ({
  children,
  usePreWrapper = true,
}: {
  children?: string;
  usePreWrapper?: boolean;
}) => {
  return usePreWrapper ? (
    <>
      <pre className="whitespace-pre-wrap font-fustat">{children}</pre>
    </>
  ) : (
    <>
      <pre className="markdown !list-disc whitespace-pre-wrap font-fustat">
        <Markdown remarkPlugins={[remarkGfm]}>{children}</Markdown>
      </pre>
    </>
  );
};
